var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _g2, _path38, _g3, _path39, _path40, _g4, _g5, _path41, _g6, _path42, _g7, _path43, _g8, _g9, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCongratulation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 196,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.446 188.092c37.003 0 67-29.997 67-67s-29.997-67-67-67-67 29.997-67 67 29.997 67 67 67z",
    fill: "url(#congratulation_svg__paint0_linear_102_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.446 191.092c38.66 0 70-31.34 70-70s-31.34-70-70-70-70 31.34-70 70 31.34 70 70 70z",
    stroke: "#D8D7E1",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.416 109.2h-.024c-23.855 0-43.193 19.338-43.193 43.193 0 23.855 19.338 43.193 43.193 43.193h.024c23.855 0 43.193-19.338 43.193-43.193 0-23.855-19.338-43.193-43.193-43.193z",
    fill: "url(#congratulation_svg__paint1_linear_102_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.587 130.051c4.937 0 8.939-4.001 8.939-8.936s-4.002-8.936-8.939-8.936-8.939 4.001-8.939 8.936 4.002 8.936 8.939 8.936z",
    fill: "url(#congratulation_svg__paint2_linear_102_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.433 130.051c4.937 0 8.939-4.001 8.939-8.936s-4.002-8.936-8.939-8.936-8.939 4.001-8.939 8.936 4.002 8.936 8.939 8.936z",
    fill: "url(#congratulation_svg__paint3_linear_102_3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.519 126.477a4.915 4.915 0 100-9.83 4.916 4.916 0 100 9.83z",
    fill: "url(#congratulation_svg__paint4_linear_102_3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.606 126.477a4.915 4.915 0 100-9.83 4.916 4.916 0 100 9.83z",
    fill: "url(#congratulation_svg__paint5_linear_102_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.581 129.158a6.703 6.703 0 006.704-6.702 6.703 6.703 0 00-6.704-6.702 6.703 6.703 0 00-6.704 6.702 6.703 6.703 0 006.704 6.702z",
    fill: "url(#congratulation_svg__paint6_linear_102_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.439 129.158a6.703 6.703 0 100-13.404 6.703 6.703 0 100 13.404z",
    fill: "url(#congratulation_svg__paint7_linear_102_3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.481 188.14c10.367 0 18.772-8.402 18.772-18.767s-8.404-18.767-18.772-18.767c-10.367 0-18.772 8.402-18.772 18.767s8.404 18.767 18.772 18.767z",
    fill: "url(#congratulation_svg__paint8_linear_102_3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.115 188.14c10.367 0 18.772-8.402 18.772-18.767s-8.405-18.767-18.772-18.767c-10.367 0-18.772 8.402-18.772 18.767s8.405 18.767 18.772 18.767z",
    fill: "url(#congratulation_svg__paint9_linear_102_3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.201 168.478c9.133 0 16.537-7.402 16.537-16.532 0-9.13-7.404-16.532-16.537-16.532s-16.537 7.402-16.537 16.532c0 9.13 7.404 16.532 16.537 16.532z",
    fill: "url(#congratulation_svg__paint10_linear_102_3)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.404 188.14c8.886 0 16.09-7.202 16.09-16.086 0-8.884-7.204-16.086-16.09-16.086s-16.09 7.202-16.09 16.086c0 8.884 7.204 16.086 16.09 16.086z",
    fill: "url(#congratulation_svg__paint11_linear_102_3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.054 167.586c8.886 0 16.09-7.202 16.09-16.086 0-8.884-7.204-16.086-16.09-16.086s-16.09 7.202-16.09 16.086c0 8.884 7.204 16.086 16.09 16.086z",
    fill: "url(#congratulation_svg__paint12_linear_102_3)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.748 188.14c14.564 0 26.37-11.803 26.37-26.363 0-14.56-11.806-26.363-26.37-26.363-14.564 0-26.37 11.803-26.37 26.363 0 14.56 11.806 26.363 26.37 26.363z",
    fill: "url(#congratulation_svg__paint13_linear_102_3)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.954 188.14c14.564 0 26.37-11.803 26.37-26.363 0-14.56-11.806-26.363-26.37-26.363-14.564 0-26.37 11.803-26.37 26.363 0 14.56 11.806 26.363 26.37 26.363z",
    fill: "url(#congratulation_svg__paint14_linear_102_3)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.073 65.324l-4.875-2.01 1.23 9.364 5.5 3.059-1.855-10.413z",
    fill: "#F48850"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.325 35.797v3.914l5.533 2.861V38.65l-5.533-2.852z",
    fill: "#FDD40B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.612 30.442l1.969-5.913h9.045l-1.162 3.247-9.852 2.666z",
    fill: "#47D2F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.274 27.486l1.32-5.812 14.073-6.375-1.301 9.057-14.092 3.13z",
    fill: "#F88B52"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.987 5.797l-1.033 10.94c.17.17 4.183-2.301 4.183-2.301 0 .17 1.602-9.653 1.602-9.653l-4.752 1.014z",
    fill: "#FFDE00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.237 39.903l2.479 3.875-4.436 8.261-3.4-5.459 5.357-6.677z",
    fill: "#FC5C54"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.874 38.322l2.285 1.434 1.064 7.615-3.349-1.95v-7.099z",
    fill: "#F88B52"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.223 87.371l5.057-3.906 6.828 5.314-3.752 2.479-8.133-3.887z",
    fill: "#48D2F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.456 115.916l1.511-4.836h7.176l-1.291 3.127-7.396 1.709z",
    fill: "#F88B52"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131.176 125.233v3.734l3.813 2.785.6-4.006-4.413-2.513zM122.161 140.301l-2.424 2.6 5.09 2.488 3.199-2.488-5.865-2.6z",
    fill: "#FDD40B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M142.78 150.201l-4.457 2.225 8.643 6.148 5.273-3.248-9.459-5.125z",
    fill: "#48D4F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M113.071 164.264l.182 7.43 2.9 1.666-.619-7.454-2.463-1.642z",
    fill: "#48D1F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8 169.25l4.966.569-7.123 7.466-3.172-3.75 5.328-4.285z",
    fill: "#FABB25"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.962 147.781l-6.92 2.127v3.92l6.58-3.261.34-2.786zM53.551 163.791l3.5 2.328-1.093 5.233-3.852-1.457 1.445-6.104z",
    fill: "#F88B52"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.753 163.356l4.716-1.42-.818 5.599-4.934.91 1.036-5.089z",
    fill: "#FC5C54"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.846 144.211l-2.048 3.113 6.925 3.231.448-5.07-5.325-1.274z",
    fill: "#FBC41C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.403 143.281l4.8-1.451 1.45-7.301h-5.115l-1.135 8.752z",
    fill: "#FDD40B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.407 134.153l-4.973.457-2.1 8.5 5.456-1.684 1.617-7.273z",
    fill: "#47D4ED"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.645 164.024l-4.906 1.931 3.424 3.272 5.03-2.543-3.548-2.66zM12.784 179.668l.615 4.85 6.979 2.519v-4.818l-7.594-2.551z",
    fill: "#FAC31B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.239 150.461c1.849 0 4.307-7.173 5.49-16.022 1.183-8.849-1.277-16.022-5.49-16.022s-6.673 7.173-5.487 16.022c1.186 8.849 3.638 16.022 5.487 16.022z",
    fill: "#FFD731"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter0_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.236 150.461c1.849 0 4.307-7.173 5.49-16.022 1.183-8.849-1.277-16.022-5.49-16.022s-6.673 7.173-5.487 16.022c1.186 8.849 3.638 16.022 5.487 16.022z",
    fill: "#fff"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.054 83.679S54.3 93.71 62.871 122.819c2.681 7.552 4.782 6.669 6.064 5.673a126.22 126.22 0 007.359-10.513l-9.24-34.3z",
    fill: "#7F3BF8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter1_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.054 83.677s-12.754 10.031-4.183 39.14c2.681 7.552 4.782 6.669 6.064 5.673a126.22 126.22 0 007.359-10.513l-9.24-34.3z",
    fill: "#fff"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.288 83.679s12.754 10.031 4.183 39.14c-2.681 7.552-4.782 6.669-6.064 5.673a126.102 126.102 0 01-7.359-10.513l9.24-34.3z",
    fill: "#48E5EE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter2_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.289 83.677s12.754 10.031 4.183 39.14c-2.681 7.552-4.782 6.669-6.064 5.673a126.102 126.102 0 01-7.359-10.513l9.24-34.3z",
    fill: "#fff"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.018 118.315h-17.9v3.258a3.265 3.265 0 003.269 3.258h11.36a3.268 3.268 0 003.02-2.009c.165-.396.25-.82.251-1.249v-3.258z",
    fill: "url(#congratulation_svg__paint15_linear_102_3)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M93.648 37.45c4.562 6.76 24.1 38.7 3.364 81.208H75.806c-20.738-42.509-1.2-74.448 3.364-81.208 4.564-6.76 7.24-6.583 7.24-6.583s2.679-.176 7.238 6.583z",
    fill: "#FED708"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter3_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.648 37.45c4.562 6.76 24.1 38.7 3.364 81.208H75.806c-20.738-42.509-1.2-74.448 3.364-81.208 4.564-6.76 7.24-6.583 7.24-6.583s2.679-.176 7.238 6.583z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter4_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.648 37.45c4.562 6.76 24.1 38.7 3.364 81.208H75.806c-20.738-42.509-1.2-74.448 3.364-81.208 4.564-6.76 7.24-6.583 7.24-6.583s2.679-.176 7.238 6.583z",
    fill: "#fff"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.011 42.379a66.402 66.402 0 013.432-5.7c4.562-6.763 7.24-6.587 7.24-6.587s2.678-.177 7.24 6.583a66.058 66.058 0 013.286 5.433 23.948 23.948 0 01-10.87 2.384 24.442 24.442 0 01-10.328-2.113z",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter5_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.009 42.374a66.387 66.387 0 013.432-5.7c4.562-6.763 7.24-6.587 7.24-6.587s2.678-.177 7.24 6.583a66.058 66.058 0 013.286 5.433 23.948 23.948 0 01-10.87 2.384 24.442 24.442 0 01-10.328-2.113z",
    fill: "#fff"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.053 64.474a7.9 7.9 0 017.915-7.887h6.2a7.9 7.9 0 017.915 7.887v6.513a7.9 7.9 0 01-7.915 7.887h-6.2a7.9 7.9 0 01-7.915-7.887v-6.513z",
    fill: "#fff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter6_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.049 64.474a7.9 7.9 0 017.915-7.887h6.2a7.9 7.9 0 017.915 7.887v6.513a7.9 7.9 0 01-7.915 7.887h-6.2a7.9 7.9 0 01-7.915-7.887v-6.513z",
    fill: "#fff"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M77.806 64.475v6.516a5.152 5.152 0 005.162 5.14h6.2a5.153 5.153 0 005.158-5.14v-6.516a5.151 5.151 0 00-5.162-5.144h-6.2a5.153 5.153 0 00-5.158 5.144z",
    fill: "url(#congratulation_svg__paint16_linear_102_3)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter7_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.439 91.219a2.599 2.599 0 012.626-2.742 2.6 2.6 0 012.624 2.742l-1.366 34.3c-.049 1.514-.841 2.742-1.765 2.742h1.016c-.926 0-1.716-1.229-1.765-2.742l-1.37-34.3z",
    fill: "#3B2617"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#congratulation_svg__filter8_d_102_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.439 91.219a2.599 2.599 0 012.626-2.742 2.6 2.6 0 012.624 2.742l-1.366 34.3c-.049 1.514-.841 2.742-1.765 2.742h1.016c-.926 0-1.716-1.229-1.765-2.742l-1.37-34.3z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint0_linear_102_3",
    x1: 84.446,
    y1: 190.638,
    x2: 84.446,
    y2: 54.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F48E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint1_linear_102_3",
    x1: 15.622,
    y1: 92.268,
    x2: 240.147,
    y2: 289.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F48E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint2_linear_102_3",
    x1: 57.587,
    y1: 113.948,
    x2: 57.587,
    y2: 129.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint3_linear_102_3",
    x1: 109.433,
    y1: 113.948,
    x2: 109.433,
    y2: 129.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint4_linear_102_3",
    x1: 45.519,
    y1: 117.62,
    x2: 45.519,
    y2: 126.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint5_linear_102_3",
    x1: 120.606,
    y1: 117.62,
    x2: 120.606,
    y2: 126.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint6_linear_102_3",
    x1: 36.581,
    y1: 117.081,
    x2: 36.581,
    y2: 128.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint7_linear_102_3",
    x1: 130.439,
    y1: 117.081,
    x2: 130.439,
    y2: 128.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint8_linear_102_3",
    x1: 58.481,
    y1: 154.322,
    x2: 58.481,
    y2: 186.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint9_linear_102_3",
    x1: 112.115,
    y1: 154.322,
    x2: 112.115,
    y2: 186.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint10_linear_102_3",
    x1: 48.201,
    y1: 138.687,
    x2: 48.201,
    y2: 167.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint11_linear_102_3",
    x1: 84.404,
    y1: 159.153,
    x2: 84.404,
    y2: 186.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint12_linear_102_3",
    x1: 121.054,
    y1: 138.599,
    x2: 121.054,
    y2: 166.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint13_linear_102_3",
    x1: 0.378,
    y1: 155.081,
    x2: 53.111,
    y2: 186.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint14_linear_102_3",
    x1: 141.846,
    y1: 151.337,
    x2: 169.315,
    y2: 186.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F48E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint15_linear_102_3",
    x1: 86.068,
    y1: 118.315,
    x2: 86.068,
    y2: 124.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311E11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3D29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "congratulation_svg__paint16_linear_102_3",
    x1: 77.806,
    y1: 65.161,
    x2: 90.568,
    y2: 78.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#D4F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter0_d_102_3",
    x: 67.451,
    y: 118.417,
    width: 37.572,
    height: 68.044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.333333 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter1_d_102_3",
    x: 57.909,
    y: 76.677,
    width: 30.385,
    height: 59.463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.282353 0 0 0 0 0.898039 0 0 0 0 0.933333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter2_d_102_3",
    x: 96.049,
    y: 76.677,
    width: 34.385,
    height: 59.463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.372549 0 0 0 0 0.282353 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter3_d_102_3",
    x: 28.447,
    y: 0.867,
    width: 85.923,
    height: 133.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -15,
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.270588 0 0 0 0 0 0 0 0 0.357 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter4_d_102_3",
    x: 58.447,
    y: 30.867,
    width: 65.923,
    height: 123.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627 0 0 0 0 0.627451 0 0 0 0 0.247059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter5_d_102_3",
    x: 62.009,
    y: 23.087,
    width: 35.198,
    height: 28.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter6_d_102_3",
    x: 70.049,
    y: 51.587,
    width: 32.03,
    height: 32.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter7_d_102_3",
    x: 78.435,
    y: 88.477,
    width: 15.258,
    height: 49.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.502 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "congratulation_svg__filter8_d_102_3",
    x: 80.435,
    y: 83.477,
    width: 15.258,
    height: 49.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.686275 0 0 0 0 0.4 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_102_3",
    result: "shape"
  })))));
}

export default SvgCongratulation;